import React from 'react';
import PropTypes from 'prop-types';
import Currency from '@prisjakt/ui-currency';

import * as S from './styles';

const PriceLabel = props => {
  const { value, medium, styling, bold, campaignStyling } = props;

  const labelStyling = campaignStyling && {
    color: campaignStyling.text,
    background: campaignStyling.background,
  };

  return (
    <S.PriceLabel
      medium={medium}
      bold={bold}
      campaign={campaignStyling}
      styling={styling}
      style={labelStyling}
    >
      {typeof value === 'number' ? <Currency price={value} /> : value}
    </S.PriceLabel>
  );
};

const { string, bool, node, oneOfType, oneOf, number } = PropTypes;

PriceLabel.propTypes = {
  value: oneOfType([number, string, node]).isRequired,
  bold: bool,
  medium: bool,
  styling: oneOf(['primary', 'secondary', 'lighten']),
  campaignStyling: PropTypes.shape({
    text: PropTypes.string,
    background: PropTypes.string,
  }),
};

PriceLabel.defaultProps = {
  bold: true,
  medium: false,
  styling: 'primary',
  campaignStyling: null,
};

export default PriceLabel;
